
require("./../../node_modules/@module-federation/nextjs-mf/src/include-defaults");
import Head from 'next/head'
import '@/styles/global.scss'
import Navbar from '@/components/Navbar'
import Footer from '@/components/Footer'
import aliancaIco from '+/favicon_stage.ico'
import {UserStoreProvider} from '@/providers/userProvider'
import {AppPropsWithLayout} from '@/types'
import {TelemetryProvider} from '@/providers/telemetryProvider'
import {QueryClient, QueryClientProvider} from '@tanstack/react-query'
import {useEffect, useState} from 'react'

const queryClient = new QueryClient()

const App = ({Component, pageProps}: AppPropsWithLayout) => {
  const [rerender, setRerender] = useState(false)

  const getLayout = Component.getLayout ?? (page => page)

  useEffect(() => {
    setTimeout(() => {
      /**
       * This timeout yields a second rerender,
       * ensuring McModals' content across the application
       * to be visible.
       */
      setRerender(true)
    })
  }, [])

  return (
    <>
      <Head>
        <link rel="shortcut icon" href={aliancaIco.src} type="image/x-icon" />
        <title>Aliança | New Vendor Portal</title>
      </Head>
      <TelemetryProvider>
        <QueryClientProvider client={queryClient}>
          <UserStoreProvider>
            <Navbar />
            {rerender ? getLayout(<Component {...pageProps} />) : undefined}
            <Footer />
          </UserStoreProvider>
        </QueryClientProvider>
      </TelemetryProvider>
    </>
  )
}

export default App
